import React from "react";
import './style.css';

const Loader_5 = () => {
  return (
    <div className="loader-5">
      <div className="loader mx-auto"></div>
    </div>
  );
};

export default Loader_5;